import { useContext, useRef, useState } from 'react';

import { useCurrentUserWithRole } from '../../../../../../../courses/hooks';
import { selectAccessibilityPrefs } from '../../../../../../../db/app/selectors';
import { selectComment } from '../../../../../../../db/comments/selectors';
import { useAppSelector } from '../../../../../../../store/hooks';
import { CommentsContext } from '../../../../../../Context';
import {
  getCommentAriaLabel,
  getCommentAttachment,
  getCommentStatsAriaLabel,
} from '../../../../../../helpers';

export interface Props {
  commentId: MongoId;
}

const useCommentVM = ({ commentId }: Props) => {
  const { turnOff } = useAppSelector((state) => selectAccessibilityPrefs(state));
  const isScreenReaderOn = !turnOff;

  const commentStatsButtonRef = useRef<HTMLButtonElement>(null);

  const comment = useAppSelector((state) => selectComment(state, commentId));

  const currentUser = useCurrentUserWithRole();
  const attachment = getCommentAttachment(comment);

  const { setSelectedCommentId } = useContext(CommentsContext);

  const commentAriaLabel = getCommentAriaLabel(comment, attachment);

  const handleCommentClick = () => {
    setSelectedCommentId(commentId);
  };

  /** comment stats dialog */

  const [isCommentStatsDialogOpen, setIsCommentStatsDialogOpen] = useState(false);

  const handleCloseStatsDialog = async () => {
    setIsCommentStatsDialogOpen(false);
    await new Promise((resolve) => setTimeout(resolve, 0));
    console.log(commentStatsButtonRef.current);
    commentStatsButtonRef.current?.focus();
  };

  const handleStatsClick = () => {
    setIsCommentStatsDialogOpen(true);
  };

  /** image preview dialog */

  const [selectedCommentImagePreviewUrl, setSelectedCommentImagePreviewUrl] = useState<string | null>(null);

  const isImagePreviewDialogOpen = Boolean(selectedCommentImagePreviewUrl);

  const handleCloseImagePreviewDialog = () => {
    setSelectedCommentImagePreviewUrl(null);
  };

  const handleImageClick = (imageUrl: string) => {
    setSelectedCommentImagePreviewUrl(imageUrl);
  };

  const commentStatsAriaLabel = getCommentStatsAriaLabel(comment);

  return {
    isScreenReaderOn,
    comment,
    commentAriaLabel,
    commentStatsAriaLabel,
    currentUser,
    attachment,
    handleCommentClick,
    commentStatsButtonRef,
    isCommentStatsDialogOpen,
    handleCloseStatsDialog,
    handleStatsClick,
    selectedCommentImagePreviewUrl,
    isImagePreviewDialogOpen,
    handleCloseImagePreviewDialog,
    handleImageClick,
  };
};

export default useCommentVM;
